// Loading splash shown while /auth/me resolves on boot.

import { useT } from '@fajrarabi/i18n/react';
import { BrandLockup, Spinner } from '@fajrarabi/ui';

export function AppSplash() {
  const t = useT();
  return (
    <div className="grid min-h-dvh place-items-center bg-cream-50 p-6">
      <div className="flex flex-col items-center gap-6 text-center">
        <BrandLockup />
        <div className="flex items-center gap-3 text-ink-500">
          <Spinner />
          <span className="text-sm">{t('app.common.loading')}</span>
        </div>
      </div>
    </div>
  );
}
